export default __webpack_public_path__ + "static/media/grad caps.ceeea095.svg";